import { useState, useEffect } from 'react';
import Home from './Home'; // Assicurati che Home.jsx sia nella stessa cartella /src
import Login from './Login'; // Se usi Login.jsx

const BASE_URL = 'https://trading.godev.it'; // Cambia con il tuo dominio PHP (dove hai login.php e check_session.php)

export default function App() {
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    async function checkSession() {
      try {
        const response = await fetch(`${BASE_URL}/check_session.php`);
        const result = await response.json();
        setLoggedIn(result.logged_in);
      } catch (error) {
        console.error('Errore controllo sessione:', error);
      }
    }
    checkSession();
  }, []);

  if (!loggedIn) {
    return <Login onLoginSuccess={() => setLoggedIn(true)} />;
  }

  return <Home />;
}
